import { InMemoryCache } from "@apollo/client";

import { possibleTypes } from "@shared/data/client";

const getCache = () =>
  new InMemoryCache({
    possibleTypes,
  });

export { getCache };
